import React, { useEffect, useState } from "react";
import { withRouter, Route, Switch } from "react-router-dom";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import Home from "./Components/Home";
// import Shipper from "./Components/Shipper";
import Partner from "./Components/Partner";
import Network from "./Components/Network";
// import Transporter from "./Components/Tranporter";
import Blog from "./Components/Blog";
import AboutUs from "./Components/AboutUs";
import Gstin from "./Components/Gstin";
import ContactUs from "./Components/ContactUs";
import Careers from "./Components/Careers";
// import Assist from "./Components/Assist";
import TermsCondition from "./Components/TermsCondition";
import Faq from "./Components/Faq";
import PrivacyPolicy from "./Components/PrivacyPolicy";
import Door from "./Components/Door";
import Individual from "./Components/Individual";
// import Enterprice from "./Components/Enterprice";
import UserAgreement from "./Components/UserAgreement";
import InsuaranceFaqs from "./Components/InsuaranceFaqs";
// import ShippingApi from "./Components/ShippingApi";
import Branch2 from "./Components/Branch2";
// import Door1 from "./Components/Door1";
// import CarrierIntegration from "./Components/CarrierIntegration";

// import "./css/bootstrap.min.css";
import "./font-awesome/css/font-awesome.min.css";
import "./plugins/cubeportfolio/css/cubeportfolio.min.css";
import "./css/nivo-lightbox.css";
import "./css/nivo-lightbox-theme/default/default.css";
import "./css/owl.carousel.css";
import "./css/owl.theme.css";
import "./css/animate.css";
import "./css/style.css";
import "./assets/vendor/icofont/icofont.min.css";
import "./assets/vendor/remixicon/remixicon.css";
import "./assets/vendor/boxicons/css/boxicons.min.css";
import "./color/default.css";
import indivisualRegistration from "./Components/indivisualRegistration";
// import CompanyWithUs from "./Components/CompanyWithUs";
// import CustomerRegistration from "./Components/CustomerRegistration";
// import RegisterWithUs from "./Components/RegisterWithUs";
import CustomerUrl from './Components/CustomerUrl';
import PartnerUrl from './Components/PartnerUrl';
// import Insurance from "./Components/Insurance";
import IntraCityForm from './Components/IntraCityForm';
import DomesticForm from "./Components/DomesticForm";
import PartloadForm from "./Components/PartloadForm";
import FullloadForm from "./Components/FullloadForm";
import PackersAndMoversForm from './Components/PackersAndMoversForm';
import InterNationalForm from './Components/InterNationalForm';
import { Page_404 } from "../../Components/ErrorHandling/Page_404/Page_404";
import { Page_500 } from "../../Components/ErrorHandling/Page_Internal_Server_Error/Page_500";

const useScript = (url: any) => {
  useEffect(() => {
    const script = document.createElement("script");

    script.src = url;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [url]);
};

const TaptapWeb = () => {
  useScript("js/jquery.min.js");
  // useScript("js/bootstrap.min.js");
  useScript("js/jquery.easing.min.js");
  useScript("js/wow.min.js");
  useScript("js/jquery.scrollTo.js");
  useScript("js/jquery.appear.js");
  useScript("js/stellar.js");
  useScript("plugins/cubeportfolio/js/jquery.cubeportfolio.min.js");
  useScript("js/owl.carousel.min.js");
  useScript("js/nivo-lightbox.min.js");
  useScript("js/custom.js");

  const [isOnline, setIsOnline] = useState(navigator.onLine);
    
  useEffect(() => {
      const handleOnline = () => setIsOnline(true);
      const handleOffline = () => setIsOnline(false);
      
      window.addEventListener('online', handleOnline);
      window.addEventListener('offline', handleOffline);
      
      return () => {
          window.removeEventListener('online', handleOnline);
          window.removeEventListener('offline', handleOffline);
      };
  }, []);

  const offlineError : any = {
      backgroundColor: `#ffcccc`,
      color: `#ff0000`,
      width : "100%",
      height : "fitContent",
      margin : "auto",
      textAlign: `center`,
      zIndex: `inherit`,
  }

  const displayNone = {
      display : "none",
  }

  return (
    <div id="page-top" data-spy="scroll" data-target=".navbar-custom">
      <div id="wrapper">
        <div style={isOnline ? displayNone : offlineError}>
            Please check your internet connection and try again.
        </div>
        <Header deviceStatus={isOnline} />
        <Switch>
          {/* <Route path="/shipper" component={Shipper} /> */}
          {/* <Route path="/transporter" component={Transporter} /> */}
          <Route path="/blog" component={Blog} />
          <Route path="/partner" component={Partner} />
          <Route path="/kabra-express/our-networks" component={Network} />
          <Route path="/aboutUs" component={AboutUs} />
          <Route path="/companyDetails" component={Gstin} />
          <Route path="/contact-us" component={ContactUs} />
          <Route path="/careers" component={Careers} />
          {/* <Route path="/assist" component={Assist} /> */}
          <Route path="/terms-and-condition" component={TermsCondition} />
          <Route path="/faq" component={Faq} />
          <Route path="/privacy-and-policy" component={PrivacyPolicy} />
          <Route path="/door" component={Door} />
          <Route path="/individual" component={Individual} />
          {/* <Route path="/enterprice" component={Enterprice} /> */}
          <Route path="/useragreement" component={UserAgreement} />
          <Route path="/insuarancefaqs" component={InsuaranceFaqs} />
          {/* <Route path="/shippingapi" component={ShippingApi} /> */}
          {/* <Route path="/registerWithUs" component={RegisterWithUs} /> */}
          <Route path="/customer" component={CustomerUrl} />
          <Route path="/partners" component={PartnerUrl} />
          <Route path="/branch2" component={Branch2} />
          {/* <Route path="/door1" component={Door1} /> */}
          {/* <Route path="/insurance" component={Insurance} /> */}
          <Route path="/intra-city" component={IntraCityForm} />
          <Route path="/domestic" component={DomesticForm} />
          <Route path="/part-load" component={PartloadForm} />
          <Route path="/full-load" component={FullloadForm} />
          <Route path="/packers-and-movers" component={PackersAndMoversForm} />
          <Route path="/international" component={InterNationalForm} />
          <Route
            path="/indivisualRegistration"
            component={indivisualRegistration}
          />
          {/* <Route path="/partnerwithus" component={CompanyWithUs} /> */}
          {/* <Route path="/specialData" component={RegisterWithUs} /> */}
          {/* <Route
            path="/CustomerRegistration"
            component={CustomerRegistration}
          /> */}
          {/* <Route path="/carrierintegration" component={CarrierIntegration} /> CI */}
          <Route path={`/404`} component={Page_404}/>
          <Route path={`/500`} component={Page_500} />
          <Route path="*" component={Home} />
        </Switch>
        {window.location.pathname === "/" || window.location.pathname === "/#" || window.location.pathname === "/customer" || window.location.pathname === "/partners" 
          || window.location.pathname === "/insurance" || window.location.pathname === "/intra-city" || window.location.pathname === "/domestic"
          || window.location.pathname === "/part-load" || window.location.pathname === "/full-load" || window.location.pathname === "/packers-and-movers"
          || window.location.pathname === "/international" || window.location.pathname === "/aboutUs" || window.location.pathname === "/partners" ? "" : <Footer />}
      </div>
    </div>
  );
};

export default withRouter(TaptapWeb);
